import type { AxiosInstance, AxiosRequestConfig } from "axios";
import {
  type OperationResponse,
  type Parameters,
  type UnknownParamsObject,
} from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils";
import type * as Paths from "./paths";

interface OperationMethods {
  "calculate"(
    parameters?: Parameters<UnknownParamsObject> | null,
    data?: Paths.Calculate.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.Calculate.Responses.$200>;

  "generateDocument"(
    parameters?: Parameters<Paths.GenerateDocument.PathParameters> | null,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GenerateDocument.Responses.$200>;
}

export const getDocumentOperations = (client: AxiosInstance) => {
  const generateDocument: OperationMethods["generateDocument"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/document/{id}/generate";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  const calculate: OperationMethods["calculate"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/document/calculate";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    generateDocument,
    calculate,
  };
};
